import {
    TogglesReduxState,
    ElectionDefinition,
    getElectionToggles,
} from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { calcRem } from '@news-mono/component-library'
import { billboardLeaderboardMrec } from '../ad-units'

export const getElectionSegment = (
    electionDefinition: ElectionDefinition,
    toggles: TogglesReduxState,
) => {
    const { logo, electionId } = electionDefinition
    const {
        'election-navigation': isNavigationEnabled,
        'election-homepage-the-race': isTheRaceEnabled,
        'election-homepage-the-seats': isTheSeatsEnabled,
        'election-homepage-collection': isCollectionEnabled,
        'election-homepage-head-to-head': isHeadToHeadEnabled,
        'election-homepage-map': isMapEnabled,
    } = getElectionToggles(electionDefinition, toggles)

    return isCollectionEnabled
        ? [
              ...(isHeadToHeadEnabled
                  ? [
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                verticalSpacing: 'md',

                                breakpoints: {
                                    lg: {
                                        horizontalGuttersOverride: 15,
                                    },
                                },
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'election-head-to-head-seat-count-widget',

                                        props: {
                                            electionDefinition,
                                            headingLevel: 'h3',
                                        },
                                    }),
                                ],
                            },
                        }),
                    ]
                  : []),
              ...(isNavigationEnabled
                  ? [
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                verticalSpacing: 'md',
                                breakpoints: {
                                    lg: {
                                        verticalSpacing: 'xxxl',
                                        horizontalGuttersOverride: 15,
                                    },
                                },
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'election-navigation',
                                        props: {
                                            electionDefinition,
                                            electionLogo: logo,
                                        },
                                    }),
                                ],
                            },
                        }),
                    ]
                  : []),

              layout.nestedComposition({
                  type: 'thor',
                  props: {
                      hasBackgroundFill: false,
                      containerWidth: '100%',
                      verticalGutters: false,
                      horiziontalGutters: true,
                  },
                  contentAreas: {
                      main: [
                          ...(isTheRaceEnabled
                              ? [
                                    layout.nestedComposition({
                                        type: 'box',
                                        props: {
                                            verticalSpacing: 'md',
                                            breakpoints: {
                                                lg: {
                                                    verticalSpacing: 'xxxl',
                                                },
                                            },
                                        },
                                        contentAreas: {
                                            main: [
                                                layout.component({
                                                    type: 'election-the-race-widget',

                                                    props: {
                                                        electionDefinition,
                                                        headingLevel: 'h3',
                                                    },
                                                }),
                                            ],
                                        },
                                    }),
                                ]
                              : []),

                          layout.nestedComposition({
                              type: 'box',
                              props: {
                                  verticalSpacing: 'md',
                                  breakpoints: {
                                      lg: {
                                          verticalSpacing: 'xxxl',
                                      },
                                  },
                              },
                              contentAreas: {
                                  main: [
                                      layout.component({
                                          type: 'sierra',
                                          props: {
                                              cardLayout: [
                                                  'the-west-hero',
                                                  {
                                                      type: 'november',
                                                      listLength: 4,
                                                      hasBackground: false, //So that the border appears on the last item ¯\_(ツ)_/¯
                                                      paddingOverride: calcRem(
                                                          16,
                                                          0,
                                                          0,
                                                          0,
                                                      ),
                                                  },
                                              ],
                                              isLarge: true,
                                              heroBottomPadding: 8,
                                              dataDefinitionArgs: {
                                                  type: 'curation',
                                                  name: electionId,
                                                  pageSize: 5,
                                                  offset: 0,
                                              },
                                              gridGap: 24,
                                              breakpoints: {
                                                  lg: {
                                                      gridGap: 32,
                                                  },
                                              },
                                          },
                                      }),
                                  ],
                              },
                          }),
                          ...(isTheSeatsEnabled
                              ? [
                                    layout.nestedComposition({
                                        type: 'box',
                                        props: {
                                            verticalSpacing: 'md',
                                            breakpoints: {
                                                lg: {
                                                    verticalSpacing: 'xxxl',
                                                },
                                            },
                                        },
                                        contentAreas: {
                                            main: [
                                                layout.component({
                                                    type: 'election-seat-widget',

                                                    props: {
                                                        electionDefinition,
                                                        electoratePageUrl: `/politics/${electionId}/electorates`,
                                                        headingLevel: 'h3',
                                                        titleText:
                                                            'Electorate Results',
                                                    },
                                                }),
                                            ],
                                        },
                                    }),
                                ]
                              : []),
                          ...(isMapEnabled
                              ? [
                                    layout.nestedComposition({
                                        type: 'box',
                                        props: {
                                            verticalSpacing: 'md',
                                            breakpoints: {
                                                lg: {
                                                    verticalSpacing: 'xxxl',
                                                },
                                            },
                                        },
                                        contentAreas: {
                                            main: [
                                                layout.component({
                                                    type: 'election-map-overview-widget',
                                                    props: {
                                                        headingLevel: 'h3',
                                                        titleText:
                                                            'Map overview',
                                                        electionDefinition,
                                                    },
                                                }),
                                            ],
                                        },
                                    }),
                                ]
                              : []),
                      ],
                  },
              }),

              ...billboardLeaderboardMrec('election'),
          ]
        : []
}
